import React from 'react';
import { Pagination as GeneralPagination } from 'views/components/General';
import styles from './style.module.scss';

const Pagination = props => {
  return (
    <div className={styles['pagination']}>
      <GeneralPagination {...props} />
    </div>
  );
};

export default Pagination;
